import React, { Component } from "react";
import {
  Row,
  Col,
  InputGroup,
  Table,
  Button,
  InputGroupAddon,
  Input
} from "reactstrap";

import { reduxForm } from "redux-form";
import { connect } from "react-redux";
import Select from "react-select";
import BlockUi from "react-block-ui";
import "react-block-ui/style.css";
import DatePicker from "react-datepicker";
import Collapsible from 'react-collapsible';
import "react-datepicker/dist/react-datepicker.css";
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import Pagination from "react-js-pagination";
import "react-confirm-alert/src/react-confirm-alert.css";

import DisplayRecordText from "../../controls/_DisplayRecordText"
import CheckboxTreeList from "../../controls/_CheckboxTreeList";

import { storedb } from "../../client/storedb"
import { currentDate, formatDateTime } from "../../../lib/common";

// Import actions
import * as actions from './actions'

class ActivityLog extends Component {
  constructor(props) {
    super(props);
    let dbContext = storedb();
    this.state = {
      storeId: dbContext.getStoreId(),
      startDate: currentDate().startOf('month'),
      endDate: currentDate(),
      userId: 0,
      activityType: {},
      page: 1,
      per_page: 50,
      itemsChecked: [],
      keyword: ''
    };
  }
  handleSearchChange = (name, e, value) => {
    switch (name) {
      case "keyword":
        this.setState({ keyword: e.target.value });
        break;
      default:
        break;
    }
  }
  handleStartdateChange = (date) => {
    this.setState({ startDate: date });
  }
  handleEnddateChange = (date) => {
    this.setState({ endDate: date });
  }
  handlePerPageChange = (perPage) => {
    this.setState({ per_page: perPage }, this.loadData)
  }
  handlePageChange = (page) => {
    this.setState({ page }, this.loadData)
  }
  getRequestData = (isExoprt, page) => {
    let requestData = {
      user_id: this.state.userId,
      activity_type: this.state.activityType ? this.state.activityType.value : null,
      start_date: formatDateTime(this.state.startDate, 'YYYYMMDD'),
      end_date: formatDateTime(this.state.endDate, 'YYYYMMDD'),
      store_id: this.state.storeId,
      keyword: this.state.keyword
    }
    if (!isExoprt) {
      requestData.page = this.state.page
      requestData.per_page = this.state.per_page
    }
    return requestData
  }
  loadData = () => {
    const formData = this.getRequestData(false)
    this.props.loadActivities(formData)
  }
  loadExcel = () => {
    const dialogSaveFile = (data) => {
      var dataFile = new Blob([data], {
        type: "application/vnd.ms-excel;charset=UTF-8"
      });
      var fileURL = URL.createObjectURL(dataFile);
      var id = 'dlinkExport';
      var fileName = "ds_lichsu_hoatdong.xls";
      var link = document.getElementById(id);
      if (link == null) {
        var a = document.createElement('a');
        a.style = "display:none;";
        a.id = "dlinkExport";
        document.body.appendChild(a);
        link = a;
      }
      var filename = prompt("File name", fileName);
      if (filename) {
        link.href = fileURL;
        link.download = filename;
        link.click();
      }
    }
    const formData = this.getRequestData(true)
    this.props.loadExcelActivities(formData,dialogSaveFile)
  }
  removeLogs = (removeAll) => {
    let { itemsChecked } = this.state
    if (removeAll) {
      itemsChecked = this.props.activities.list.map((item) => { return item.Id })
    }

    const requestData = {
      items: itemsChecked
    }
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className='custom-ui'>
            <h1>THÔNG BÁO?</h1>
            <p>Xác nhận xoá?
          </p>
            <button className="text-danger" onClick={() => {
              this.props.removeLogs(requestData, () => {
                this.loadData()
              })
              onClose()
            }}>Đồng ý</button>
            <button onClick={onClose}>Hủy bỏ</button>
          </div>
        )
      }
    })
  }
  handleAvtivityTypeChange = (e) => {
    this.setState({ activityType: e }, this.loadData)
  }
  onHandleChoice = (usersChecked) => {
    this.setState({ userId: usersChecked[0].value }, this.loadData)
  }
  itemChecked = ({ target }) => {
    let { itemsChecked } = this.state
    const value = target.value
    if (target.checked) {
      const index = itemsChecked.indexOf(value)
      if (index === -1) {
        itemsChecked.push(value)
      }
    } else {
      const index = itemsChecked.indexOf(value)
      if (index > -1) {
        itemsChecked.splice(index, 1)
      }
    }
    this.setState({ itemsChecked })
  }
  keyPress = (e) => {
    if(e.keyCode == 13){
       this.loadData()
    }
  }
  componentDidMount() {
    this.props.loadUsers({
      store_id: this.state.storeId,
      is_only_inherit: true
    })
    this.props.loadActivityTypes({
      store_id: this.state.storeId,
    })
    this.loadData()
  }
  render() {
    const {
      activities: {
        requesting,
        total_record,
        activityTypes,
        list,
        users
      },
    } = this.props

    const {
      page,
      per_page,
      itemsChecked
    } = this.state

    const getOptionsType = (items) => {
      if (items == null) return []
      return items.map((item) => { return { value: item.Id, label: item.Name } })
    }
    const beginIndex = (page - 1) * per_page
    return (
      <div className="animated fadeIn">
        <BlockUi tag="div" blocking={requesting}>
          <div>
            <Collapsible trigger="Tìm kiếm..." overflowWhenOpen="inherit" open={true}>
              <Row>
                <Col sm="12" className="mb-1 mr-0">
                  <InputGroup size="md">
                    <InputGroupAddon addonType="prepend" autoComplete="off" >Từ khóa</InputGroupAddon>
                    <Input name="keyword" placeholder="Từ khóa tìm kiếm, Số hóa đơn" autoComplete="off" 
                      value={this.state.keyword} 
                      onChange={this.handleSearchChange.bind(this, "keyword")} 
                      onKeyDown={e => this.keyPress(e)}/>
                  </InputGroup>
                </Col>
                <Col sm="3" xs="6" md="2" className="mb-1 pr-1 mr-0">
                  <InputGroup size="md">
                    <DatePicker
                      name="startDate"
                      dateFormat="DD/MM/YYYY"
                      placeholderText="Từ ngày"
                      selected={this.state.startDate}
                      onChange={e => this.handleStartdateChange(e)}
                      className={"form-control"}
                      autoComplete="off"
                    />
                  </InputGroup>
                </Col>
                <Col sm="3" xs="6" md="2" className="mb-1 pl-1 mr-0">
                  <InputGroup size="md">
                    <DatePicker
                      name="endDate"
                      dateFormat="DD/MM/YYYY"
                      placeholderText="Đến ngày"
                      selected={this.state.endDate}
                      onChange={e => this.handleEnddateChange(e)}
                      className={"form-control"}
                      autoComplete="off"
                    />
                  </InputGroup>
                </Col>
                <Col sm="3" xs="12" md="4" className="mb-1 mr-0">
                  <Select
                    placeholder="Chọn hoạt động"
                    value={this.state.activityType}
                    onChange={e => this.handleAvtivityTypeChange(e)}
                    options={getOptionsType(activityTypes)}
                    isClearable={true}
                  />
                </Col>
                <Col sm="3" xs="12" md="4" className="mb-1 mr-0">
                  <CheckboxTreeList
                    placeholder={`--Nhân viên--`}
                    nodes={users}
                    checked={this.state.userId}
                    isMultiChoice={false}
                    onChoice={e => this.onHandleChoice(e)}
                  />
                </Col>
              </Row>
            </Collapsible>
          </div>
          <div className="mt-2 bg-white">
            <div className="w-100 mb-2">
              <Button size="md" color="success" className="pull-left mr-1" onClick={e => this.loadData()}>
                <i className="fa fa-search mr-1" />Tìm kiếm
              </Button>
              <Button size="md" color="primary" className="pull-left mr-1" onClick={e => this.loadExcel()}>
                <i className="fa fa-file-excel-o mr-1" />Xuất excel
              </Button>
              <Button disabled={itemsChecked.length === 0} size="md" color="warning" className="pull-left mr-1" onClick={e => this.removeLogs()}>
                <i className="fa fa-close mr-1" />Xoá chọn
              </Button>
              <Button size="md" color="danger" className="pull-left" onClick={e => this.removeLogs(true)}>
                <i className="fa fa-close mr-1" />Xoá tất cả
              </Button>
              <div className="clearfix"></div>
            </div>
            <div className="w-100">
              <DisplayRecordText
                itemsCountPerPage={per_page}
                onChangeItem={(e) => this.handlePerPageChange(e)}
              />
              <Table hover responsive className="table-outline table-sm mb-0 d-sm-table table table-hover">
                <thead className="thead-default">
                  <tr>
                    <th scope="col" width="30" className="text-center table-border-right">#</th>
                    <th scope="col" width="20" className="text-center table-border-right"></th>
                    <th scope="col" width="130" className="text-center table-border-right">Loại</th>
                    <th scope="col" width="130" className="text-center table-border-right">Nhân viên</th>
                    <th scope="col" width="130" className="text-center table-border-right">Thời gian</th>
                    <th scope="col" className="text-left table-border-right">Nội dung</th>
                  </tr>
                </thead>
                <tbody>
                  {list && !!list.length && (
                    list.map((res, idx) => (
                      <tr key={idx + 1}>
                        <td className="text-center table-border-right">{beginIndex + idx + 1}</td>
                        <td className="text-center table-border-right"><input type="checkbox" value={res.Id} onChange={e => this.itemChecked(e)} /></td>
                        <td className="text-left table-border-right">{res.ActivityLogType}</td>
                        <td className="text-left table-border-right">{res.CreateBy}</td>
                        <td className="text-center table-border-right">{formatDateTime(res.CreatedOn, "HH:mm DD-MM-YYYY")}</td>
                        <td className="text-left table-border-right">{res.Comment}</td>
                      </tr>
                    ))
                  )}
                </tbody>
              </Table>
              {total_record > per_page && (
                <nav>
                  <Pagination
                    activePage={page}
                    itemsCountPerPage={per_page}
                    totalItemsCount={total_record}
                    pageRangeDisplayed={5}
                    onChange={this.handlePageChange}
                  />
                </nav>
              )}
            </div>
            <div className="clearfix"></div>
          </div>
        </BlockUi>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  activities: state.activities,
  client: state.client
});

const connected = connect(
  mapStateToProps,
  {
    loadUsers: actions.loadUsers,
    loadActivityTypes: actions.loadActivityTypes,
    loadActivities: actions.loadActivities,
    loadExcelActivities: actions.loadExcelActivities,
    removeLogs: actions.removeLogs
  }
)(ActivityLog);

const formed = reduxForm({
  form: "orders"
})(connected);

export default formed;



// WEBPACK FOOTER //
// ./src/views/Admin/ActivityLog/ActivityLog.js